module.exports = __webpack_public_path__ + "static/media/icsa-logo-compact-rgb-core.5a88d9ca.png";